import { getBuyerId } from 'dibs-cookie-jar';
import serverVars from 'server-vars';

import isPageType from '../../../utils/isPageType';
import { PAGE_TYPE } from '../../../utils/pageConstants';
import {
    isValidProgram,
    isValidDate,
    canLevelUp,
    willLoseStatus,
    hasSeenRewardsMessagingModal,
    logRewardsMessagingModalView,
} from '../../../TradeRewardsEndOfYearMessagingModal/tradeRewardsEndOfYearMessagingHelpers';

import { fetchQuery, graphql, Environment } from 'react-relay';
import idx from 'idx';

import { tradeRewardsEndOfYearMessagingRule_Query as Query } from './__generated__/tradeRewardsEndOfYearMessagingRule_Query.graphql';

const query = graphql`
    query tradeRewardsEndOfYearMessagingRule_Query($userId: String!) {
        viewer {
            user(userId: $userId) {
                tradeFirmRewards {
                    ...tradeRewardsEndOfYearMessagingHelpers_rewards
                }
            }
        }
    }
`;

async function queryFirmRewardsStatus(
    userId: string,
    relayEnvironment: Environment
): Promise<boolean> {
    const data = await fetchQuery<Query>(relayEnvironment, query, {
        userId,
    });
    const rewards = idx(data, d => d.viewer.user.tradeFirmRewards);
    const showMessagingModal =
        isValidProgram(rewards) && (canLevelUp(rewards) || willLoseStatus(rewards));

    if (showMessagingModal) {
        logRewardsMessagingModalView();
        return true;
    }
    return false;
}

export function tradeRewardsEndOfYearMessagingRule({
    relayEnvironment,
}: {
    relayEnvironment: Environment;
}): Promise<boolean> {
    const isUserTypeTrade = !!serverVars.get('settings.isUserTypeTrade');
    const isDesktop = !!serverVars.get('settings.isDesktop');
    const isBlacklistedPage = isPageType([
        PAGE_TYPE.CHECKOUT,
        PAGE_TYPE.CHECKOUT_CONFIRMATION,
        PAGE_TYPE.ORDER_MANAGER,
        PAGE_TYPE.TRADE_REWARDS,
    ]);

    const userId = getBuyerId(document.cookie);
    if (
        !isValidDate() ||
        !userId ||
        !isUserTypeTrade ||
        !isDesktop ||
        isBlacklistedPage ||
        hasSeenRewardsMessagingModal()
    ) {
        return Promise.resolve(false);
    }

    return queryFirmRewardsStatus(userId, relayEnvironment);
}
